import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useMemo } from "react";

import { FillScreen } from "@/components/Layout";
import {
  PackagePatternConfigTable,
  type PackageType,
} from "@/features/operation-package-config-new/PackagePatternConfig";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { featureFlags } from "@/lib/env";

export const Route = createFileRoute("/_staff/labor-core/_packages/configs/")({
  component: ConfigsPage,
});

function ConfigsPage() {
  useDocumentTitle("Operation Package | Configs");

  const navigate = useNavigate();

  const handlePatternRowClick = (patternId: string) => {
    navigate({
      to: "/labor-core/config/$patternId",
      params: { patternId },
    });
  };

  // Feature Flag でパッケージをフィルタリング
  const excludePackageTypes = useMemo((): PackageType[] | undefined => {
    const isGovernmentApplicationEnabled = featureFlags.check("NewFeature");
    if (isGovernmentApplicationEnabled) {
      return undefined;
    }
    return ["GovernmentApplication"];
  }, []);

  return (
    <FillScreen className="flex flex-col gap-4 px-12 py-5">
      <PackagePatternConfigTable
        ownerProduct="HRF_LABOR_CORE"
        handlePatternRowClick={handlePatternRowClick}
        excludePackageTypes={excludePackageTypes}
      />
    </FillScreen>
  );
}
